import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import { Form, Icon, Input, Button, Tooltip, Card, Spin, Row, Col, Select } from 'antd';
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
const { Option } = Select;

class NewUser extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            user: null,
            loadingUser: true,
            loadingChange: false,
        }
    }

    componentDidMount() {
        this.getUser()
    }

    getUser() {
        this.setState({
            user:  {"id": 1, "nombre": "Jorge Karucha", "tipo": "ADMIN", "createdon": "01/03/20, 01:26:07", "lastlogin": "01/10/20, 19:56:45"},
            loadingUser: false
        })
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        if (this.state.loadingUser) {
            return (
                <>
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                    <Col style={{minHeight:'360px'}}>
                        <Spin indicator={CustomSpinner}/>
                    </Col>
                </Row>
                <Row></Row>
                </>)
        }

        return(
            <Card style={{maxWidth:"500px", margin:"auto"}}>
                <Form
                    onSubmit={(e)=>this.onSubmit(e)}
                    hideRequiredMark={true}
                >
                    <Form.Item
                    >
                    {
                        getFieldDecorator('user', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Nombre de usuario requerido',
                                },
                            ]
                        })(<Input
                                prefix={<Icon type="user" />}
                                placeholder="Usuario"
                                suffix={
                                    <Tooltip title="Modificar nombre de usuario">
                                        <Icon type="info-circle" />
                                    </Tooltip>
                                }
                            />)
                    }
                    </Form.Item>
                    <Form.Item
                    >
                    {
                        getFieldDecorator('tipo', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Tipo de usuario requerido',
                                },
                            ]
                        })(
                        <Select
                            placeholder="Tipo"
                        >
                            <Option value="ADMIN">Admin</Option>
                            <Option value="OPERADOR">Operador</Option>
                        </Select>
                        )
                    }
                    </Form.Item>
                    <Form.Item>
                        <Button
                            onClick={(e) => this.props.form.resetFields()}
                            style={{marginRight:"10px"}}
                        >
                            Reiniciar campos
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{margin:"auto"}}
                            loading={this.state.loadingChange}
                        >
                            Crear usuario usuario
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        );
    }
}

const NewUserForm = Form.create({ name: 'new-user' })(NewUser);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewUserForm));
